module.exports = __webpack_public_path__ + "static/img/225.007bac32.png";